import {
  createRootRoute,
  createRoute,
  createRouter,
  Outlet,
} from "@tanstack/react-router";
import { RootLayout } from "./routes/__root";
import { IndexRoute } from "./routes/index";
import { BriefsNewRoute } from "./routes/briefs.new";
import { AuthCallbackRoute } from "./routes/auth.callback";

const rootRoute = createRootRoute({
  component: () => (
    <RootLayout>
      <Outlet />
    </RootLayout>
  ),
});

const indexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/",
  component: IndexRoute,
});

const briefsNewRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/briefs/new",
  component: BriefsNewRoute,
});

const authCallbackRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/auth/callback",
  component: AuthCallbackRoute,
});

const routeTree = rootRoute.addChildren([indexRoute, briefsNewRoute, authCallbackRoute]);

export const router = createRouter({ routeTree });

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
